module.exports = __webpack_public_path__ + "img/SKLB-Solicitud.9c96740a.png";